import React, { forwardRef } from 'react';

import { StyledIcon } from '../StyledIcon';

const Print = forwardRef((props, ref) => (
  <StyledIcon ref={ref} viewBox="0 0 24 24" a11yTitle="Print" {...props}>
    <path d="M18.5 10C19.3284 10 20 10.6716 20 11.5C20 12.3284 19.3284 13 18.5 13H17.5C16.6716 13 16 12.3284 16 11.5C16 10.6716 16.6716 10 17.5 10H18.5Z" fill="#000" /><path fillRule="evenodd" clipRule="evenodd" d="M16 0C17.6569 0 19 1.34315 19 3V6H21C22.6569 6 24 7.34315 24 9V17C24 18.6569 22.6569 20 21 20H19V21C19 22.6569 17.6569 24 16 24H8C6.34315 24 5 22.6569 5 21V20H3C1.34315 20 0 18.6569 0 17V9C0 7.34315 1.34315 6 3 6H5V3C5 1.34315 6.34315 0 8 0H16ZM7 21C7 21.5523 7.44772 22 8 22H16C16.5523 22 17 21.5523 17 21V17H7V21ZM3 8C2.44772 8 2 8.44772 2 9V17C2 17.5523 2.44772 18 3 18H5V17C4.44772 17 4 16.5523 4 16C4 15.4477 4.44772 15 5 15H19V18H21C21.5523 18 22 17.5523 22 17V9C22 8.44772 21.5523 8 21 8H3ZM8 2C7.44772 2 7 2.44772 7 3V6H17V3C17 2.44772 16.5523 2 16 2H8Z" fill="#000" />
  </StyledIcon>
));

Print.displayName = 'Print';

export { Print };
